
















import { Component, Vue, Prop } from 'vue-property-decorator'
import { query } from '@/store/snackbar'

@Component<Snackbar>({
  apollo: {
    snackbar: {
      query
    }
  }
})
export default class Snackbar extends Vue {
  snackbar = null
}
